module.exports = __webpack_public_path__ + "static/img/Receive1.b8d8657.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Receive1.png
// module id = Lr4T
// module chunks = 0